var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({attrs:{"outlined":"","dense":"","background-color":"background_color","hide-details":"auto","label":`${_vm.label} ${_vm.required ? ' *' : ''}`,"rules":[
    ...(_vm.required ? [(val) => !!val || `${_vm.label} is required`] : []),
    ..._vm.rules,
  ]}},'v-textarea',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }